import { useState } from "react";
import {
  Typography,
  Box,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Table,
  Tooltip,
  Link,
} from "@mui/material";
import {
  parseAnchor,
  isLinkClicked,
  markLinkClicked,
} from "../../../../../utils/functions";
import {
  BODY_SPACING,
  COMPONENT_SPACING,
} from "../../../../../utils/constants/designConstants";

export const CategorySpecificNewsTable = ({ categorySpecificNews }) => {
  const [clickedLinks, setClickedLinks] = useState(new Set());
  if (!categorySpecificNews || categorySpecificNews.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING,
          mt: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_TOP,
          mb: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_BOTTOM,
        }}
      >
        Category News aren't available at the moment.
      </Typography>
    );
  }

  const headers = ["Section", "Title", "Description", "Published"];

  return (
    <Box>
      <TableContainer component={Paper} variant="outlined">
        <Table
          sx={{ minWidth: COMPONENT_SPACING.MIN_TABLE_WIDTH }}
          stickyHeader
          aria-label="category specific news"
          size="small"
        >
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    backgroundColor: "background.paper",
                    fontWeight: "bold",
                    zIndex: 1,
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {categorySpecificNews.map((item, index) => {
              const parsedTitle = parseAnchor(item["Title"]);
              return (
                <TableRow hover>
                  <TableCell sx={{ textAlign: "center" }}>
                    {item["Monitoring Criteria"]}
                  </TableCell>
                  <TableCell
                    sx={{
                      minWidth: 200,
                      maxWidth: 470,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {parsedTitle ? (
                      parsedTitle.text.length > 85 ? (
                        <Tooltip title={parsedTitle.text} arrow>
                          <Link
                            href={parsedTitle.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() =>
                              markLinkClicked(
                                parsedTitle.href,
                                clickedLinks,
                                setClickedLinks,
                              )
                            }
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                              maxWidth: "100%",
                              fontWeight: 500,
                              color: isLinkClicked(
                                parsedTitle.href,
                                clickedLinks,
                              )
                                ? "secondary.berry"
                                : "secondary.tiffanyBlue",
                              textDecoration: "none",
                              "&: hover": { textDecoration: "underline" },
                            }}
                          >
                            {parsedTitle.text.slice(0, 85) + "..."}
                          </Link>
                        </Tooltip>
                      ) : (
                        <Link
                          href={parsedTitle.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() =>
                            markLinkClicked(
                              parsedTitle.href,
                              clickedLinks,
                              setClickedLinks,
                            )
                          }
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "inline-block",
                            maxWidth: "100%",
                            fontWeight: 500,

                            color: isLinkClicked(parsedTitle.href, clickedLinks)
                              ? "secondary.berry"
                              : "secondary.tiffanyBlue",
                            textDecoration: "none",
                            "&: hover": { textDecoration: "underline" },
                          }}
                        >
                          {parsedTitle.text}
                        </Link>
                      )
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell>{item.Description}</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    {item.Published.split(" ")[0]}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
